import utilities from "./utilities/index.js"
import feed from "./feed/feed.js"

export default {
    namespaced: true,
    modules: {
        utilities: utilities,
        feed: feed
    }
}